import { useEffect, useState, useContext } from "react";
import axios from 'axios';
import { Box, Heading } from '@chakra-ui/react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import AuthContext from "../contexts/AuthContext";

const WealthChart = () => {
    const [wealthData, setWealthData] = useState([]);
    const { getToken } = useContext(AuthContext);

    useEffect(() => {
        const fetchData = async () => {
            const token = getToken();
            try {
                const wealthResponse = await axios.get('/api/wealth_variation', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setWealthData(wealthResponse.data);
                console.log(wealthResponse.data);
            } catch (error) {
                console.error('Failed to fetch data', error);
            }
        };

        fetchData();
    }, [getToken]);

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip">
                    <p className="label">{`${label} : ${payload[0].value.toFixed(2)}`}</p>
                    {/* <p className="intro">{getIntroOfPage(label)}</p>
                    <p className="desc">Anything you want can be displayed here.</p> */}
                </div>
            );
        }

        return null;
    };

    return (
        <Box mb={4}>
            <Heading size="md" mb={4}>Patrimonio personale</Heading>
            <LineChart width={600} height={300} data={wealthData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip content={<CustomTooltip />} />
                <Legend />
                <Line type="monotone" dataKey="total" stroke="#8884d8" activeDot={{ r: 8 }} />
            </LineChart>
        </Box>
    )
};

export default WealthChart;